{
  "items": [
    "Delivered digitalised testing and documentation process for regulated IRT workflows",
    "Led testing across multiple concurrent GxP pharmaceutical projects",
    "Trained over 500 software testers in QA practices and ISTQB preparation",
    "Led a technical assessment program evaluating testers from Junior to Test Manager level",
    "Contributed to the development of testing offerings within the Sii Testing Competency Center"
  ]
}
